import React, { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import { AiFillExclamationCircle } from 'react-icons/ai';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './s-input.component.scss';

interface SSInputPhoneCodeInterface {
  name: any;
  placeholder: string;
  error: any;
  control: any;
  rules?: any;
  className?: string;
  defaultValue?: string;
  onChange?: any;
}

const SInputPhoneCodeComponent = ({ name, error, defaultValue, onChange, placeholder, className, control, rules }: SSInputPhoneCodeInterface) => {
  return (
    <div className={`s-input-wrapper ${className} ${error ? 'error' : ''}`}>
      <Controller
        defaultValue={defaultValue ? defaultValue : ''}
        name={name}
        control={control}
        rules={rules}
        render={({ field }) =>
          <PhoneInput
            {...field}
            defaultCountry="SG"
            className="form-control s-input d-flex"
            placeholder={placeholder}
            onChange={data => { field.onChange(data); onChange && onChange(data) }} />}
      />
      <OverlayTrigger
        // show={!!error}
        trigger={["hover", "hover"]}
        placement="top"
        overlay={<Tooltip id={`tooltip-${name}`}>{error?.message}</Tooltip>}
      >
        <AiFillExclamationCircle className="text-danger position-absolute error-icon" size={22} />
      </OverlayTrigger>
    </div>
  )
}

export default React.memo(SInputPhoneCodeComponent)
